
import CloseButton from '@/components/buttons/dedicated/CloseButton.vue';
import LoadingOverlay from '@/components/loaders/LoadingOverlay.vue';
import MobileHeaderLayout from '@/components/mobile/MobileHeaderLayout.vue';
import MobileHeaderTabs from '@/components/mobile/MobileHeaderTabs.vue';
import { Icon } from '@/lib/enum/Icon';
import { IconSettings, MobileHeaderTab } from '@/lib/mobileHeader';
import { elementIsScrolledToBottom, viewport } from '@/util/windowFunctions';
import DialogHeader from '@/views/settings/modals/DialogHeader.vue';
import { PropType } from 'vue';

export default {
  name: 'Dialog',

  components: {
    CloseButton,
    DialogHeader,
    MobileHeaderTabs,
    MobileHeaderLayout,
    LoadingOverlay,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    fullscreen: {
      type: Boolean,
      default: null,
    },
    // On mobile fullscreen dialog header should still be visible
    dialogHeaderFullscreen: {
      type: Boolean,
      default: false,
    },
    headerTabs: {
      type: Array as PropType<MobileHeaderTab[]>,
      default: () => [],
    },
    headerRight: {
      type: Object as PropType<IconSettings> | null,
      default: null,
    },
    maxWidth: {
      type: [String, Number],
      default: 550,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    value: {
      // v-dialog will cope with truthy/falsey values, so allowing multiple types can yield some convenient shortcuts
      type: [Boolean, Object, String],
      default: false,
    },
    popUp: {
      type: Boolean,
      default: false,
    },
    transition: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      contentCanScroll: false,
      viewport,
      Icon,
    };
  },

  computed: {
    displayFullscreen(): boolean {
      if (this.fullscreen !== null) {
        return this.fullscreen;
      }
      return !viewport.md;
    },
    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  mounted() {
    // When the dialog is resized vertically, the amount of space given to the content area will change,
    // so observe this, and update our contentCanScroll property
    const resizeObserver =
      typeof ResizeObserver === 'undefined'
        ? null
        : new ResizeObserver(() => {
            window.requestAnimationFrame(() => {
              if (this.$refs.content) {
                this.contentCanScroll = !elementIsScrolledToBottom(
                  this.$refs.content,
                );
              }
            });
          });

    this.$nextTick(() => {
      if (resizeObserver && this.$refs.content) {
        resizeObserver.observe(this.$refs.content);
      }
    });
  },

  methods: {
    close() {
      this.isVisible = false;
    },
    handleScroll({ target }) {
      this.contentCanScroll = !elementIsScrolledToBottom(target);
    },
  },
};
